<template>
<div>
    <div class="mt-5 mx-10 d-flex justify-space-between">
        <img src="assets/logo-sm.svg" alt="">
        <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          class="d-flex align-center mt-3 pl-5 pr-2 py-2 rounded"
          style="background: white; box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06); height: 42px"
          @click="menuOpen = !menuOpen"
        >
          <span class="mr-5 text-capitalize darkBlue--text font-weight-black text-body-2">{{userName}}</span>
          <v-icon color="#505D6F" v-if="!menuOpen">mdi-chevron-down</v-icon>
          <v-icon color="#505D6F" v-else>mdi-chevron-up</v-icon>
        </div>
      </template>
      <v-list dense>
        <v-list-item @click="goTo('/login')">
          <v-list-item-title class="font-weight-bold darkBlue--text">Logout</v-list-item-title>
        </v-list-item>
        <v-list-item @click="goTo('/changepwd')">
          <v-list-item-title class="font-weight-bold darkBlue--text">Change Password</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    </div>
    <v-row v-if="this.appItems.length <= 0">
      <center>
        You have not been assigned any application/s. Please contact the apps
        admin.
      </center>
    </v-row>
    <v-row class="d-flex justify-center align-center mx-7" style="height: 90vh">
      <v-col cols="3" style="width: 310px" v-for="apps in appItems" :key="apps.app_id">
        <v-card :loading="loading" class="my-12 custom-shadow" flat>
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <div class="pt-3">
            <v-img height="250" :src="apps.image_path" contain />
          </div>

          <v-card-title class="darkBlue--text font-weight-bold">
              <h3>{{ apps.app_name }}</h3>
          </v-card-title>

          <v-card-text>
            <p class="body-1 grey--text">{{ apps.description }}</p>
          </v-card-text>

          <v-card-actions class="mx-2">
            <v-btn
              color="rgba(23, 168, 130, 0.2)"
              depressed
              :loading="appId === apps.app_id && isLoading"
              block
              height="38"
              @click="openurl(apps.app_url_withkey, apps.app_id)"
            >
              <span class="text-capitalize font-weight-bold green--text body-1">Open</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
</div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from "../../../apis/apifactory";

Vue.use(VueAxios, axios);
export default {
  name: "ExtraAuth",
  data: () => ({
    userid: null,
    appItems: null,
    appItemsprefered: "",
    appId: null,
    msg: "",
    menuOpen: false,
    isLoading: false
  }),
  computed: {
    appitemfirst() {
      return this.appItems.length;
    },
    userName () {
      return localStorage.getItem("SET_USERNAME")
    }
  },
  mounted() {
    this.getstoragevalues();
    this.getloginuserapp();
  },
  methods: {
    checkauth() {
      this.getauthdata();
      this.loginusername = "";
    },
    getstoragevalues() {
      this.userid = localStorage.getItem("SET_USERID");
    },
    getloginuserapp() {
      apifactory
        .getloginuserapps(this.userid)
        .then((res) => {
          // alert(res.status);

          if (res.status != 200) {
            alert(res.data.message);
          } else {
            this.appItems = res.data;
          }
        })
        .catch(function(error) {
          console.warn(error);
        });
    },

    goTo(url) {
      return this.$router.push(url);
    },
    openurl(url, app_id) {
      this.appId = app_id;
      window.location.href = url
      this.isLoading = true
    },
  },
};
</script>

<style scoped>
.linkdiv {
  cursor: pointer;
}
</style>
